import { Outlet } from "react-router-dom";

// Components
import MobileDeviceDetector from "components/common/mobiledetector/MobileDeviceDetector";
import { AppUpdateBanner } from "components/common/AppUpdateBanner";
import { PanelHeader } from "components/dashboard/body/PanelHeader";
import { ProjectAreaSidebar } from "components/layout/shell/AppSidebar";
import { GlobalNavigationSearchProvider } from "components/layout/shell/GlobalNavigationSearch";
import { SidebarProvider, SidebarInset } from "components/common/Sidebar/Sidebar";
import { sidebarShellContentPanelClassName } from "components/layout/shell/sidebarShell";
import { cn } from "utils/cn";
import { useState } from "react";
import { ProductionTypeProjectFilters } from "config";

interface DashboardLayoutProps {
  title?: string;
  showSidebar?: boolean;
  showPlanUpgradeButton?: boolean;
  children?: React.ReactNode;
}

export const DashboardLayout = ({
  title: _title,
  showSidebar = true,
  showPlanUpgradeButton: _showPlanUpgradeButton = true,
  children,
}: DashboardLayoutProps) => {
  const [gridView, setGridView] = useState<boolean>(true);
  const [productionType, setProductionType] =
    useState<keyof typeof ProductionTypeProjectFilters>("");

  return (
    <>
      {showSidebar ? (
        <SidebarProvider defaultOpen>
          <GlobalNavigationSearchProvider>
            <ProjectAreaSidebar />
          </GlobalNavigationSearchProvider>
          <SidebarInset className="flex h-full min-h-0 flex-col overflow-hidden">
            <AppUpdateBanner />
            <div
              className={cn(
                sidebarShellContentPanelClassName,
                "overflow-y-auto overflow-x-hidden px-[40px]"
              )}
            >
              <MobileDeviceDetector inproject={true} />
              <PanelHeader
                gridView={gridView}
                setGridView={setGridView}
                onProductionTypeChange={setProductionType}
              />
              <div className="min-w-0 flex-1">
                {children || <Outlet context={{ gridView, productionType }} />}
              </div>
            </div>
          </SidebarInset>
        </SidebarProvider>
      ) : (
        <div className="flex h-full min-h-0 flex-1 flex-col">
          <AppUpdateBanner />
          <div className="flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden px-[40px] min-w-0 w-full bg-background">
            <MobileDeviceDetector inproject={true} />
            <div className="min-w-0 flex-1">
              {children || <Outlet context={{ gridView, productionType }} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
